import { useEffect, useRef } from "react";

function usePrevious<T>(current: T) {
  const previous = useRef<T>(current);
  useEffect(() => {
    previous.current = current;
  }, [current]);
  return previous.current;
}

function hasChanged<T extends Array<unknown>>(prev: T, current: T) {
  return current.some((value: unknown, index) => {
    return value !== prev[index];
  });
}

export function useChanged<T extends Array<unknown>>(
  fn: (previous: T) => unknown,
  current: T,
) {
  const previous = usePrevious(current);
  const valueChanged = hasChanged(previous, current);

  useEffect(() => {
    if (valueChanged) {
      fn(previous);
    }
  });
}
